<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <div>
      <v-col
        cols="12"
        class="px-2 pt-0 border-datatable"
      >
        <v-data-table
          v-if="headers"
          v-model="selected"
          :height="tableHeight"
          fixed-header
          :headers="showHeaders"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          multi-sort
          hide-default-footer
          dense
          :show-select="showSelect"
          item-key="id"
          class="mb-0"
        >
          <template v-slot:item.row="{ item }">
            <div class="px-1">
              {{ parseInt(items.indexOf(item))+ parseInt(from) }}
            </div>
          </template>
          <template v-slot:item.name="{ item }">
            {{ $t(item.name) }}
          </template>
          <template v-slot:item.oppositeAccount="{ item }">
            <div class="py-1">
              <autocomplete
                v-model="item.given"
                class="mb-3"
                :new-btn="true"
                type="given"
              />
            </div>
          </template>
        </v-data-table>
        <v-divider />
      </v-col>
    </div>
    <v-card-actions class="pt-0">
      <v-row class="ma-0">
        <v-col
          cols="6"
          class="px-0"
        >
          <v-btn
            color="primary"
            class="mr-0"
            :loading="isLoading"
            @click="create"
          >
            {{ $t('submit') }}
          </v-btn>
        </v-col>
        <v-col
          cols="6"
          class="px-0"
        />
      </v-row>
    </v-card-actions>
    <v-row />
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import General from '../../../../../Mixins/general'
  import autocomplete from '../../../components/general/patial/autocomplete'
  export default {
    name: 'Review',
    components: {
      autocomplete,
    },
    mixins: [General],
    props: ['input', 'refId', 'accountProp', 'typeProp'],
    data: () => ({
      selected: [],
      filterType: 'month',
      filterTypeItems: null,
      excelItems: null,
      fromFinancialYear: null,
      toFinancialYear: null,
      documentType: null,
      remain: 'debtorCreditor',
      remainItems: [],
      fromMonth: null,
      fromMonthItems: null,
      toMonthItems: null,
      toMonth: null,
      fromDate: null,
      toDate: null,
      isLoading: false,
      printDialog: false,
      deletDialog: false,
      showSelect: false,
      filter: false,
      level: 'group',
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      levelItems: ['group', 'total', 'given', 'detail'],
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      total: null,
      group: null,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      fin4: null,
      given: null,
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.accountProp) {
            if (s.value === 'fin4.name' || s.value === 'given.name') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        var app = this
        app.excelItems = []
        const totals = this.items.reduce((acc, d, index) => {
          // acc.debtor += (d.sumDebtor ? parseFloat(d.sumDebtor) : 0)
          // acc.creditor += (d.sumCreditor ? parseFloat(d.sumCreditor) : 0)
          app.excelItems.push({
            row: +index + +1,
            given: (d.given ? d.given.name : null),
            fin4: (d.fin4 ? d.fin4.name : null),
            nature: app.$t(d.totalType),
            debtor: d.sumDebtor,
            creditor: d.sumCreditor,
            remain: d.remain,
          })
          return acc
        }, {
        // debtor: 0,
        // creditor: 0,
        })
        return totals
      },
    },
    watch: {
      level (val, oldVal) {
        if (val === 'back') {
          this.backLevel(oldVal)
        } else {
          this.getItems()
        }
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
    // this.getItems()
    },
    beforeMount () {
      this.headers = [
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('name'),
          sortable: false,
          value: 'name',
          width: 150,
        },
        {
          text: this.$t('oppositeGivenAccount'),
          sortable: false,
          value: 'oppositeAccount',
          width: 300,
        },
      ]
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
      this.fromFinancialYear = this.$store.state.financialYear
      this.toFinancialYear = this.$store.state.financialYear
      this.getItems()
    },
    methods: {
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'accountingEdit', params: { id: item.head_id } })
      },
      create () {
        var app = this
        app.loading = true
        var formData = new FormData()
        formData.append('select', 'getGivenSetting')
        formData.append('items', JSON.stringify(this.items))
        app.$axios.post(this.$endpoint + 'createdetail', formData)
          .then(res => {
            app.snakbarText = app.$t('alert-created')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.loading = false
          })
      },
      makeExcel () {
        var app = this
        app.excelItems = []
        this.items.map(function (d, index) {
          app.excelItems.push({
            row: +index + +1,
            given: (d.given ? d.given.name : null),
            fin4: (d.fin4 ? d.fin4.name : null),
            nature: app.$t(d.totalType),
            debtor: d.sumDebtor,
            creditor: d.sumCreditor,
            remain: d.remain,
          })
        })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'getdetail', {
          params: {
            select: 'getGivenSetting',
          },
        })
          .then(res => {
            res = res.data
            app.items = res
            app.totalItems = 10
            app.from = 1
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.loading = false
            app.makeExcel()
          })
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'invoice/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      turnover (item) {
        this.$router.push({ name: 'turnoverDetail', params: { id: item.fin4_id, accountProp: { fin_id: item.fin4_id, name: item.fin4.name }, tabName: item.fin4.name } })
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style  lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.border-datatable
  .theme--light.v-data-table
    .v-data-table__wrapper
      table
        thead
          tr:last-child
            th
              border-top : 1px solid #e3e3e3 !important
              border-left : 1px solid #e3e3e3 !important
              padding : 0px 8px !important
              background-color: #f5f5f5

  .theme--light.v-data-table
    .v-data-table__wrapper
      table
        thead
          tr:last-child
            th:first-child
              border-right : 1px solid #e3e3e3 !important

  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row)
    border-left : 1px solid #e3e3e3 !important
    padding : 0px 8px !important
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row):first-child, .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row)
    border-right : 1px solid #e3e3e3 !important
    padding : 0px 8px !important
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td:first-child:not(.v-data-table__mobile-row)
    border-right : 1px solid #e3e3e3 !important
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td:last-child:not(.v-data-table__mobile-row)
    border-left : 1px solid #e3e3e3 !important
</style>
